<template>
<!--  <div class="sys">
    <div v-for="(item,index) in infoData" :key="index" v-html="item.NewsDesc"></div>
  </div>-->
<div class="sysDetails">
  <div class="background">
    <div class="background-img"><img :src="img_1" style="width:450px;height:340px"></div>
    <div class="background-text">
      <p>EasyIotSharp平台</p>
    </div>
  </div>

  <div class="system-video">
    <video src="@/assets/EasyIotSharp.mp4" poster="../../assets/26.jpg" style="width: 600px;height: 500px" controls muted></video>
    <div class="system-video-text">
      <h9>EasyIotSharp平台</h9>
    </div>
    <div class="system-video-text2">
      <h11><br>在万物互联的时代，物联网应用开发面临诸多挑战：多协议适配复杂、海量设备管理困难、实时响应要求高、<br>
        数据可视化需求迫切。EasyIotSharp 应运而生——这是一款专为物联网场景设计的轻量级开源支撑平台，通<br>
        过模块化架构和即插即用组件，让开发者能够快速构建稳定、高效的物联网解决方案。</h11>
    </div>
  </div>

  <div class="system-carousel">
    <h1 class="blue center">系统部分功能截图</h1>
    <swiper ref="systemSwiper" :options="systemSwiperOption" class="system-swiper">
      <swiper-slide v-for="index in 8" :key="index" class="swiper-system">
        <img :src="require(`../../assets/system/1-${index}.png`)" :alt="`系统图${index}`" class="carousel-system">
      </swiper-slide>
      <!-- 分页器 -->
      <div class="swiper-pagination" slot="pagination"></div>
      <!-- 左右箭头 -->
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
  </div>

</div>
</template>

<script>
import system from "@/views/system/system.vue";
import 'swiper/dist/css/swiper.css'


export default {
  name: "sysDetails",
  computed: {
    system() {
      return system
    }
  },
  data(){
    return{
      infoData:[],
      img_1:require('../../assets/05.png'),

      systemSwiperOption: {
        slidesPerView: 3, // 显示5张图片（当前1张+左右各2张）
        spaceBetween: 20, // 图片间距
        centeredSlides: true, // 当前图片居中
        loop: true, // 开启循环播放
        loopAdditionalSlides: 8, // 额外复制4张幻灯片用于循环
        initialSlide: 1, // 明确设置初始slide
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        observer: true,
        observeParents: true,
        // 添加响应式配置
        breakpoints: {
          1024: { slidesPerView: 5 },
          768: { slidesPerView: 3 },
          480: { slidesPerView: 1 },
          320: { slidesPerView: 1 } // 新增最小屏配置
        }
      }

    }
  },
  mounted() {
    this.getInfo(this.$route.query.Id);
  },
  methods:{
    //获取xx
    getInfo(id){
      let data={params:{Id:id}}
      this.$axios.get('http://82.156.125.76:5000/api/Byt_Ent_Gateway/BytEntNewsIdSelect',data).then(res=> {
        res = typeof res.data=='string'? JSON.parse(res.data):res.data;
        this.infoData = res.data;
        console.log(res.data)
      })
    },
  }
}
</script>

<style scoped>
/*最上方背景*/
.background {
  background-color: #f5f5f5; /* 浅灰色背景 */
  width: 100%; /* 宽度100% */
  height: 300px; /* 最小高度 */
  padding: 20px; /* 内边距 */
  border-radius: 8px; /* 圆角 */
  box-shadow: 0 2px 10px rgba(0,0,0,0.1); /* 阴影效果 */
}
.background-img {
  position: relative;
  left: 60%;
  top: -15px;
}
.background-text{
  position: relative;
  font-size: 50px;
  font-weight: 700;
  font-family: "Microsoft YaHei";
  left: 27%;
  top: -300px;
}
.system-video{
  position: relative;
  left: 20%;
  top: 40px;
  height: 600px;
}
.system-video-text{
  position: relative;
  left: 45%;
  top: -400px;
}
.system-video-text2{
  position: relative;
  left: 35%;
  top: -400px;
}



/* 新增轮播样式 */
.system-carousel {
  position: relative;
  top: -300px;
  margin: 60px auto;
  padding: 0 20px;
}

.system-swiper {
  height: 450px; /* 调整为合适高度 */
  width: 1500px;
  margin: 0 auto;
}

/* 新增图片放大相关样式 */
.swiper-system {
  overflow: hidden;
  transition: all 0.5s ease;
  transform: scale(0.7); /* 增加默认缩放比例 */
  opacity: 0.8; /* 提高默认透明度 */
}

.swiper-system.swiper-slide-active {
  transform: scale(1);
  opacity: 1;
  z-index: 2;
}

.swiper-system.swiper-slide-next,
.swiper-system.swiper-slide-prev {
  transform: scale(0.9); /* 增加相邻图片缩放比例 */
  opacity: 0.95;
  z-index: 1;
}

.carousel-system {
  width: 100%;
  height: 400px; /* 固定图片高度 */
  object-fit: cover; /* 保持比例并覆盖容器 */
}

/* 鼠标悬停效果优化 */
.swiper-system:hover .carousel-system {
  transform: scale(1.1);
}

.swiper-pagination-bullet-active {
  background-color: #1890ff;
}

.swiper-button-prev, .swiper-button-next {
  color: #1890ff;
}
.swiper-content{
  height: 240px;
}


/* 添加Swiper核心布局样式穿透 */
::v-deep .swiper-container {
  position: relative;
}

::v-deep .swiper-wrapper {
  display: flex !important; /* 强制横向排列 */
  transition-property: transform;
}

::v-deep .swiper-slide {
  flex-shrink: 0; /* 防止幻灯片被压缩 */
}

/* 原有样式保持不变 */
  .system-carousel {
  position: relative;
  top: -10px;
  margin: 60px auto;
  padding: 0 20px;
  overflow: hidden;
  }
  
  .system-swiper {
  height: 450px;
  width: 100%;
  max-width: 1500px;
  margin: 0 auto;
}

</style>